import React from "react";
import { ReactComponent as GoogleIconSvg } from "../images/icons/7123025_logo_google_g_icon.svg";

const GoogleIcon = () => {
  return <GoogleIconSvg style={{ width: "2rem", height: "2rem" }} />;
};

export default GoogleIcon;
